/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Members_Remove_User_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to remove {email} from the organization? This action cannot be undone." |
*
* @param {Members_Remove_User_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_remove_user_description = /** @type {((inputs: Members_Remove_User_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Remove_User_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bist du sicher, dass du ${i?.email} aus der Organisation entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to remove ${i?.email} from the organization? This action cannot be undone.`)
});